import Component from '../component/component';

import './footer.scss';

export default class Footer extends Component {
    static initSelector: string = '.footer';

    topButton: HTMLElement;

    constructor(target: HTMLElement) {
        super(target);

        this.topButton = this.element.querySelector('.footer__to-top');

        this.init();
    }

    init(): void {
        this.topButton.addEventListener('click', this.scrollToTop.bind(this));
    }

    scrollToTop(): void {
        window.scroll({
            behavior: 'smooth',
            left: 0,
            top: 0,
        });
    }
}
